import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import MarketingLayout from '../components/layout/MarketingLayout';

const ShopPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const products = [
    {
      name: "ESP32 Development Board",
      description: "Basic microcontroller for your smart garden projects",
      image: "https://m.media-amazon.com/images/I/71kMMfrr7SL._AC_SL1500_.jpg",
      link: "https://amzn.to/4sYNe6u",
      category: ["controllers"]
    },
    {
      name: "ESP32 Breakout Board",
      description: "Breakout board for easy prototyping with ESP32 microcontrollers",
      image: "https://m.media-amazon.com/images/I/716NeVDFOBL._AC_SL1500_.jpg",
      link: "https://amzn.to/3OguQ9k",
      category: ["controllers"]
    },
    {
      name: "ESP32-S3 Development Board",
      description: "More powerful microcontroller with faster processing",
      image: "https://m.media-amazon.com/images/I/71GKGndDkWL._AC_SL1200_.jpg",
      link: "https://amzn.to/3Z1oA7B",
      category: ["controllers"]
    },
    {
      name: "Soil Moisture Sensor",
      description: "Basic soil moisture sensor. Essential for irrigation automation",
      image: "https://m.media-amazon.com/images/I/71I+61-rohL._SL1500_.jpg",
      link: "https://amzn.to/4rX2fnQ",
      category: ["sensors"]
    },
    // {
    //   name: "12V Power Supply Adapter",
    //   description: "Reliable power source for your indoor garden devices",
    //   image: "https://m.media-amazon.com/images/I/51RcskuGQJL.jpg",
    //   link: "https://amzn.to/4k1gfKF",
    //   category: "power"
    // },
    // {
    //   name: "12V to 5V DC-DC Converter",
    //   description: "Step down 12V to 5V for microcontroller power",
    //   image: "https://m.media-amazon.com/images/I/5116eat7RTL._AC_SL1000_.jpg",
    //   link: "https://amzn.to/4a20oHv",
    //   category: "power"
    // },
    {
      name: "DHT11 Temperature and Humidity Sensor",
      description: "Basic sensor for monitoring temperature and humidity",
      image: "https://m.media-amazon.com/images/I/71-1n6cYeCL._SL1100_.jpg",
      link: "https://amzn.to/45tSlBQ",
      category: ["sensors"]
    },
    {
      name: "DHT22 Temperature and Humidity Sensor",
      description: "Advanced sensor with higher accuracy for temperature and humidity monitoring",
      image: "https://m.media-amazon.com/images/I/61FyqYni7jL._AC_SL1500_.jpg",
      link: "https://amzn.to/3ZDEt4g",
      category: ["sensors"]
    },
    // {
    //   name: "12V 3 Lead LED Strip",
    //   description: "Full color LED strip for dynamic lighting solutions. Ideal for indoor setups.",
    //   image: "https://m.media-amazon.com/images/I/61BBQyBI8BL._AC_SL1000_.jpg",
    //   link: "https://amzn.to/4rfyzCm",
    //   category: "misc"
    // },
    // {
    //   name: "SN74AHCT125N Level Shifter",
    //   description: "Level shifter for interfacing LED strips with 3.3V microcontrollers",
    //   image: "https://m.media-amazon.com/images/I/71nNHK2tmNL._SL1500_.jpg",
    //   link: "https://amzn.to/469vT0P",
    //   category: "misc"
    // },
    {
      name: "3.3V Power Relay Module",
      description: "Control high voltage devices like pumps and lights with this relay module compatible with 3.3V microcontrollers",
      image: "https://m.media-amazon.com/images/I/61dn-t4ztOL._SL1500_.jpg",
      link: "https://amzn.to/4trS2Se",
      category: ["lighting", "watering"]
    },
    {
      name: "Indoor Grow Lights",
      description: "Full spectrum LED grow lights for indoor gardening. Perfect for providing optimal light conditions for your plants",
      image: "https://m.media-amazon.com/images/I/61YUUd7yi-L._AC_SL1500_.jpg",
      link: "https://amzn.to/3Oxs6o7",
      category: ["lighting"]
    },
    {
      name: "Submersible Water Pump",
      description: "Submersible water pump for your indoor garden setup",
      image: "https://m.media-amazon.com/images/I/71kdxfDvWoL._AC_SL1500_.jpg",
      link: "https://amzn.to/3ZrctBa",
      category: ["watering"]
    },
    {
      name: "1/2 inch Tubing",
      description: "Tubing for connecting water pumps and irrigation systems in your indoor garden",
      image: "https://m.media-amazon.com/images/I/71HMBybQlkL._AC_SL1500_.jpg",
      link: "https://a.co/d/07TBjXyH",
      category: ["watering"]
    },
    {
      name: "Micro Sprinker Heads",
      description: "Micro sprinker heads for precise watering in your indoor garden setup",
      image: "https://m.media-amazon.com/images/I/81UjhK38ErL._AC_SL1500_.jpg",
      link: "https://amzn.to/4toWst2",
      category: ["watering"]
    },
    {
      name: "Breadboard and Jumper Wires",
      description: "Essential for prototyping and testing your smart garden circuits",
      image: "https://m.media-amazon.com/images/I/81ZsOMwOuxL._AC_SL1500_.jpg",
      link: "https://amzn.to/4ckHsWZ",
      category: ["prototyping"]
    },
    {
      name: "2 in 1 Solder and Hot Air Rework Station",
      description: "Perfect for soldering components and reworking circuits in your smart garden projects",
      image: "https://m.media-amazon.com/images/I/71xmcAZWReL._AC_SL1500_.jpg",
      link: "https://amzn.to/4aoUJvh",
      category: ["prototyping"]
    },


  ];

  const categories = [
    { key: 'all', label: 'All' },
    { key: 'controllers', label: 'Controllers' },
    { key: 'sensors', label: 'Sensors' },
    { key: 'lighting', label: 'Lighting' },
    { key: 'watering', label: 'Watering' },
    { key: 'prototyping', label: 'Prototyping' },
  ];

  const filteredProducts = selectedCategory === 'all'
    ? products
    : products.filter(product => product.category.includes(selectedCategory));

  return (
    <MarketingLayout>
      <section className="marketing-page-header">
        <Container>
          <h1>Garden Sync Shop</h1>
          <p className="lead">
            Recommended products to enhance your gardening experience with smart technology.
          </p>
        </Container>
      </section>

      <section className="marketing-content">
        <Container>
          <div className="shop-filters">
            {categories.map((category) => (
              <Button
                key={category.key}
                size="sm"
                variant={selectedCategory === category.key ? 'primary' : 'outline-primary'}
                className={selectedCategory === category.key ? 'active' : ''}
                onClick={() => setSelectedCategory(category.key)}
              >
                {category.label}
              </Button>
            ))}
          </div>

          <Row>
            {filteredProducts.map((product, index) => (
              <Col md={4} key={index} className="mb-4">
                <div className="shop-card d-flex flex-column">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="shop-card__img"
                  />
                  <div className="shop-card__body">
                    <div className="shop-card__title">{product.name}</div>
                    <p className="shop-card__text">{product.description}</p>
                    <a
                      href={product.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      View on Amazon
                    </a>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </MarketingLayout>
  );
};

export default ShopPage;